import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, input } from '@angular/core';
import { Observable } from 'rxjs';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-web-page-content',
  templateUrl: './dot-cms-web-page-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsWebPageContentComponent implements DotCmsContentTypeComponent, OnInit, AfterViewInit {
  contentlet$: Observable<CustomDotCmsContentlet>;
  readonly identifier = input<string>(undefined);
  readonly setAttribute = input<boolean>(true);

  constructor(private renderer: Renderer2, private el: ElementRef, private dotCmsFacade: DotCmsFacade) {}

  ngAfterViewInit() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }

  ngOnInit() {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());

    onClickEmaDotcmsPageLinks(this.el, this.renderer);
  }
}
